var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_984_8502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9A62E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_984_8502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.00781 4.25H14.6455C14.7727 4.25001 14.8886 4.29728 14.9688 4.37207C15.0478 4.44584 15.085 4.53856 15.085 4.62695V5.12695H17.4639C17.591 5.12695 17.7069 5.17429 17.7871 5.24902C17.8661 5.32279 17.9033 5.41551 17.9033 5.50391C17.9033 5.59228 17.8661 5.68504 17.7871 5.75879C17.7069 5.83347 17.591 5.88086 17.4639 5.88086H6.18945C6.06228 5.88084 5.94639 5.83355 5.86621 5.75879C5.7872 5.68504 5.75002 5.59228 5.75 5.50391C5.75 5.41551 5.78717 5.32279 5.86621 5.24902C5.94639 5.17421 6.06224 5.12698 6.18945 5.12695H8.56836V4.62695C8.56836 4.53859 8.60558 4.44583 8.68457 4.37207C8.7647 4.29729 8.88068 4.25009 9.00781 4.25Z",
    stroke: "url(#paint0_linear_984_8502)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0244 8.70117V18.7236C17.0244 19.0427 16.8876 19.3579 16.6289 19.5967C16.3689 19.8366 16.0085 19.9775 15.625 19.9775H8.02539C7.64175 19.9775 7.28055 19.8367 7.02051 19.5967C6.76191 19.3579 6.625 19.0426 6.625 18.7236V8.70117H17.0244ZM9.4502 9.45508C9.23471 9.45508 9.02082 9.52342 8.84668 9.65527L8.77539 9.71582C8.58869 9.88816 8.47461 10.1312 8.47461 10.3936V18.2861C8.47475 18.5483 8.58881 18.7907 8.77539 18.9629C8.96072 19.1339 9.20402 19.2236 9.4502 19.2236C9.69636 19.2236 9.93971 19.1339 10.125 18.9629C10.3115 18.7907 10.4247 18.5483 10.4248 18.2861V10.3936C10.4248 10.164 10.3381 9.94965 10.1914 9.78418L10.125 9.71582L10.0527 9.65527C9.87872 9.52362 9.66547 9.45513 9.4502 9.45508ZM14.2002 9.45508C13.954 9.45508 13.7098 9.54473 13.5244 9.71582C13.3378 9.88815 13.2246 10.1312 13.2246 10.3936V18.2861C13.2247 18.5482 13.338 18.7907 13.5244 18.9629C13.7098 19.134 13.954 19.2236 14.2002 19.2236C14.4463 19.2236 14.6897 19.1339 14.875 18.9629C15.0615 18.7907 15.1747 18.5483 15.1748 18.2861V10.3936C15.1748 10.164 15.0881 9.94965 14.9414 9.78418L14.875 9.71582L14.8027 9.65527C14.6287 9.52361 14.4155 9.45514 14.2002 9.45508Z",
    stroke: "url(#paint1_linear_984_8502)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_984_8502",
    x1: 11.8268,
    y1: 3.75,
    x2: 11.8268,
    y2: 6.38073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_984_8502",
    x1: 11.8249,
    y1: 8.20117,
    x2: 11.8249,
    y2: 20.4779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepDelete);
export default __webpack_public_path__ + "static/media/dep_delete.31c110f8c37bd69a912c854f432a40d9.svg";
export { ForwardRef as ReactComponent };